import React from "react";

import cx from "classnames";

import {DateString} from "@globals/types/utilityTypes";
import {useUser} from "@globals/user";

import styles from "./RestaurantName.scss";

type RestaurantNameProps = {
  restaurant: {slug: string; name: string};
  deliveryDate?: DateString;
  wrapperClassName?: string;
  operatorSlug: string;
};

export default function RestaurantName({
  wrapperClassName,
  restaurant,
  deliveryDate,
  operatorSlug,
}: RestaurantNameProps): JSX.Element {
  const {user} = useUser();

  return (
    <div className={wrapperClassName}>
      {user?.has_brand_page_link ? (
        <a
          href={`/brand/${operatorSlug}/${restaurant.slug}?date=${
            deliveryDate ?? ""
          }`}
          className={cx(styles.restaurantName, styles.restaurantLink)}
        >
          {restaurant.name}
        </a>
      ) : (
        <span className={styles.restaurantName}>{restaurant.name}</span>
      )}
    </div>
  );
}
